/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

import KbArticleHeaderImage from '../assets/preview-card-kb-article-header.svg';

import { createKbMessages } from './messages';

const styles = cssMap({
	imageContainer: {
		width: '100%',
	},
	image: {
		display: 'block',
		width: '100%',
		height: '210px',
		objectFit: 'cover',
	},
});

export const CreateKBCardImagePreview = (): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.imageContainer} testId="create-kb-card-image-preview">
			<Box
				as="img"
				alt={formatMessage(createKbMessages.headerImageAltMessage)}
				src={KbArticleHeaderImage}
				xcss={styles.image}
			/>
		</Box>
	);
};
